import PropTypes from 'prop-types';
import { StyledFlexContainer } from './styles';

const ToastBody = ({ msg }) => (
  <StyledFlexContainer align="center">
    <div className="toast-msg">{msg}</div>
  </StyledFlexContainer>
);

ToastBody.propTypes = {
  msg: PropTypes.string.isRequired,
};

export default ToastBody;
